// uuidを生成
const UseUuid = ()=>{
	let strong = 1000;
	let uuid = new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16);
  	return [ uuid ];
}
export default UseUuid
